import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toastr.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AsteriskDirective } from '../../common/directives/astreik.directive';
import { UserService } from '../../services/user.service';
import { UnSubscriber } from '../../common/unsubscriber';
import { GlobalService } from '../../services/global.service';
import { Router, RouterModule } from '@angular/router';
import { CommonDataStore } from '../../state-management/global.store';
import { LoaderService } from '../../services/loader.service';
import { API_KEYS } from '../../state-management/api.config';
import { SecureStorageService } from '../../services/secure-storage.service';
@Component({
  selector: 'app-login',
  imports: [CommonModule, FormsModule, AsteriskDirective, RouterModule],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login extends UnSubscriber {
  private toastService = inject(ToastService);
  private UserService = inject(UserService)
  public loaderService = inject(LoaderService)
  public globalService = inject(GlobalService)
  private router = inject(Router);
  private Commonstate = inject(CommonDataStore)
  private sessionService = inject(SecureStorageService);

  constructor() {
    super()
  }

  ngOnInit() {
    //this.toastService.error('Welcome to KUDO Score Management System');
  }

  // #region variable

  ErrorMsg: string[] = [];
  LoginData: LoginData = {
    email: '',
    password: ''
  }
  showPassword: boolean = false;

  viewMode: 'login' | 'forgot_password_email' | 'forgot_password_otp' | 'forgot_password_reset' = 'login';

  forgotPasswordData = {
    email: '',
    otp: '',
    newPassword: '',
    confirmPassword: ''
  };

  otpDigits: string[] = ['', '', '', '', '', ''];
  showNewPassword = false;
  showConfirmPassword = false;

  resendOtpTimer: number = 0;
  resendOtpInterval: any;
  // #endregion

  ValidateLogin(): boolean {
    this.ErrorMsg = [];

    const requiredFields = [
      { field: this.LoginData.email, label: 'Email' },
      { field: this.LoginData.password, label: 'Password' },
    ];

    this.ErrorMsg = this.globalService.validateFields(requiredFields);

    if (this.ErrorMsg.length) {
      this.toastService.info("Missing fields");
      return false;
    }

    return true
  }

  onLogin() {
    if (!this.ValidateLogin()) return;
    this.loaderService.requestStarted('Verifying your credentials...');
    this.anotherSubscription = this.UserService.login(this.LoginData).subscribe({
      next: (res: any) => {
        console.log(res);

        const { token, data, log_detail } = res;

        this.sessionService.setStorage('log_id', log_detail.log_id);
        this.sessionService.setStorage('token', token);
        this.sessionService.setStorage('id', data.id);
        this.sessionService.setStorage('name', data.name);
        this.sessionService.setStorage('email', data.email);
        this.sessionService.setStorage('ring_number', data.ring_number);
        this.sessionService.setStorage('mobile', data.mobile);
        this.sessionService.setStorage('tournament_id', data.tournament_id);
        // sessionStorage.setItem('role', this.globalService.encrypt(typeof data.role === 'string' ? data.role : JSON.stringify(data.role)));
        this.sessionService.setStorage('country_ids', JSON.stringify(data.country_ids || []));
        this.sessionService.setStorage('state_ids', JSON.stringify(data.state_ids || []));
        this.sessionService.setStorage('district_ids', JSON.stringify(data.district_ids || []));
        // sessionStorage.setItem('menuPermission', JSON.stringify(res.menuPermissions));
        // sessionStorage.setItem('tournamentPermissions', JSON.stringify(res.tournamentPermissions));

        this.globalService.userRole.set(data.role || []);
        this.globalService.IsLogin.set(true);
        this.Commonstate.loadAll()
        this.Commonstate.reloadapi(API_KEYS.PERMISSION, { id: Number(data.id) })
        this.loaderService.requestEnded();
        this.router.navigate(['/dashboard-view'])
      },
      error: (err: any) => {
        this.loaderService.requestEnded();
        console.error(err);
      }
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  switchToForgotPassword() {
    this.viewMode = 'forgot_password_email';
    this.LoginData = { email: '', password: '' };
    this.forgotPasswordData = { email: '', otp: '', newPassword: '', confirmPassword: '' };
    this.otpDigits = ['', '', '', '', '', ''];
    this.showPassword = false;
    this.showNewPassword = false;
    this.showConfirmPassword = false;
    this.ErrorMsg = [];
    clearInterval(this.resendOtpInterval);
    this.resendOtpTimer = 0;
  }

  switchToLogin() {
    this.viewMode = 'login';
    this.LoginData = { email: '', password: '' };
    this.forgotPasswordData = { email: '', otp: '', newPassword: '', confirmPassword: '' };
    this.otpDigits = ['', '', '', '', '', ''];
    this.showPassword = false;
    this.showNewPassword = false;
    this.showConfirmPassword = false;
    this.ErrorMsg = [];
    clearInterval(this.resendOtpInterval);
    this.resendOtpTimer = 0;
  }

  onSendOtp() {
    if (!this.forgotPasswordData.email) {
      this.toastService.error("Email is required");
      return;
    }

    this.loaderService.requestStarted('Sending OTP...');
    this.anotherSubscription = this.UserService.forgotPassword(this.forgotPasswordData.email).subscribe({
      next: (res: any) => {
        this.loaderService.requestEnded();
        this.toastService.success('Mail sent on registered email id');
        this.viewMode = 'forgot_password_otp';
        this.startResendOtpTimer();
      },
      error: (err: any) => {
        this.loaderService.requestEnded();
      }
    });
  }

  startResendOtpTimer() {
    this.resendOtpTimer = 60; // 1 minute
    clearInterval(this.resendOtpInterval);
    this.resendOtpInterval = setInterval(() => {
      if (this.resendOtpTimer > 0) {
        this.resendOtpTimer--;
      } else {
        clearInterval(this.resendOtpInterval);
      }
    }, 1000);
  }

  formatTime(seconds: number): string {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? '0' + sec : sec}`;
  }

  resendOtp() {
    if (this.resendOtpTimer > 0) return;

    this.loaderService.requestStarted('Resending OTP...');
    this.anotherSubscription = this.UserService.forgotPassword(this.forgotPasswordData.email).subscribe({
      next: (res: any) => {
        this.loaderService.requestEnded();
        this.toastService.success('OTP resent successfully');
        this.startResendOtpTimer();
      },
      error: (err: any) => {
        this.loaderService.requestEnded();
      }
    });
  }

  onVerifyOtpStep() {
    const otp = this.otpDigits.join('');
    if (otp.length < 6) {
      this.toastService.error("Please enter a valid 6-digit OTP");
      return;
    }

    this.loaderService.requestStarted('Verifying OTP...');
    const body = {
      email: this.forgotPasswordData.email,
      otp: otp
    };

    this.anotherSubscription = this.UserService.verifyOtp(body).subscribe({
      next: (res: any) => {
        this.loaderService.requestEnded();
        this.forgotPasswordData.otp = otp;
        this.viewMode = 'forgot_password_reset';
      },
      error: (err: any) => {
        this.loaderService.requestEnded();
      }
    });
  }

  trackByIndex(index: number, item: any) {
    return index;
  }

  onOtpInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (value && !/^\d$/.test(value)) {
      this.otpDigits[index] = '';
      return;
    }

    if (event.key === 'Backspace' && !value && index > 0) {
      const prevInput = document.getElementById(`otp_${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    } else if (value && index < 5) {
      const nextInput = document.getElementById(`otp_${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  onOtpPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text');
    if (pastedData) {
      const numbers = pastedData.replace(/\D/g, '').split('').slice(0, 6);
      for (let i = 0; i < numbers.length; i++) {
        this.otpDigits[i] = numbers[i];
      }
      const focusIndex = Math.min(numbers.length, 5);
      setTimeout(() => {
        const nextInput = document.getElementById(`otp_${focusIndex}`);
        if (nextInput) {
          nextInput.focus();
        }
      }, 0);
    }
  }

  onResetPassword() {
    this.ErrorMsg = [];
    const requiredFields = [
      { field: this.forgotPasswordData.newPassword, label: 'New Password' },
      { field: this.forgotPasswordData.confirmPassword, label: 'Confirm Password' }
    ];

    this.ErrorMsg = this.globalService.validateFields(requiredFields);

    if (this.ErrorMsg.length) {
      this.toastService.info("Missing fields");
      return;
    }

    if (this.forgotPasswordData.newPassword !== this.forgotPasswordData.confirmPassword) {
      this.toastService.error("Passwords do not match");
      return;
    }

    this.loaderService.requestStarted('Updating password...');
    const body = {
      email: this.forgotPasswordData.email,
      otp: this.forgotPasswordData.otp,
      new_password: this.forgotPasswordData.newPassword
    };

    this.anotherSubscription = this.UserService.verifyOtp(body).subscribe({
      next: (res: any) => {
        this.loaderService.requestEnded();
        this.toastService.success('Password updated successfully');
        this.switchToLogin();
      },
      error: (err: any) => {
        this.loaderService.requestEnded();
      }
    });
  }
}

interface LoginData {
  email: string,
  password: string
}


